import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '@xingternal/button';
import styles from './ShowMoreButton.css';

type ShowMoreButtonProps = {
  disabled?: boolean;
  loading?: boolean;
  onClick?: () => void;
  intlKey?: string;
};
const ShowMoreButton: React.FC<ShowMoreButtonProps> = ({
  disabled,
  loading,
  onClick,
  intlKey = 'CP_OTHER_INTERESTING_COMPANIES',
}) => (
  <div className={styles.paginationButtonLayout}>
    <Button
      variant="tertiary"
      className={styles.paginationButton}
      disabled={disabled}
      loading={loading}
      onClick={onClick}
    >
      <FormattedMessage id={intlKey} />
    </Button>
  </div>
);

export { ShowMoreButton };
